const ITEMS = [
  "Schools", "Colleges", "Clinics", "Hospitals",
  "Restaurants", "Cafés", "Hotels", "Retail",
  "Real Estate", "Coaching", "Salons", "Spas",
  "Pharma", "Logistics", "Wellness",
];

const Ticker = () => {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <div className="ticker" data-bg="white" data-testid="ticker">
      <div className="ticker-track">
        {loop.map((t, i) => (
          <span key={i} className="ticker-item">{t}</span>
        ))}
      </div>
    </div>
  );
};

export default Ticker;
